var _excluded = ["logo", "children", "mobileBottomChildren", "bottomBar"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { forwardRef, useContext } from "react";
import BrandContext from "../../../contexts/BrandContext";
import OnColorContext from "../../../contexts/OnColorContext";
import pageHeaderBrandStyles from "../../../theme/pageHeaderBrandStyles";
import isNotEmpty from "../../../utils/isNotEmpty";
import { Container, MobileItems, SimplePageHeaderBottomBar, StyledImage, StyledLink, StyledSimplePageHeaderMol } from "./SimplePageHeaderMol.styled";
var SimplePageHeaderMol = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var logo = _ref.logo,
    children = _ref.children,
    mobileBottomChildren = _ref.mobileBottomChildren,
    bottomBar = _ref.bottomBar,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var background = pageHeaderBrandStyles[useContext(BrandContext)].background;
  return /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: background
  }, /*#__PURE__*/React.createElement(StyledSimplePageHeaderMol, null, /*#__PURE__*/React.createElement(Container, _extends({
    ref: ref,
    $hasChildren: !!children
  }, restProps, {
    $backgroundColor: background,
    role: "banner"
  }), /*#__PURE__*/React.createElement(StyledLink, {
    to: logo.to,
    href: logo.href,
    title: logo.title,
    onClick: logo.onClick
  }, /*#__PURE__*/React.createElement(StyledImage, {
    srcData: logo.src,
    alt: logo.alt
  })), children, isNotEmpty(mobileBottomChildren) ? /*#__PURE__*/React.createElement(MobileItems, null, mobileBottomChildren) : null), isNotEmpty(bottomBar) ? /*#__PURE__*/React.createElement(SimplePageHeaderBottomBar, null, bottomBar) : null));
});
export default SimplePageHeaderMol;